import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ZipCountyModalComponent } from '../zip-county-modal.component';
import { NgRedux, select } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { setActiveProductGroup } from 'src/app/angular-elements/plan-selection/configs/reducers/plans.reducer';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { EffectiveDateStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/effective-date.state-structure.interface';
import { DateService } from 'src/app/shared/services/date.service';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { Observable } from 'rxjs';
import { ProducerUrlSessionObject } from 'src/app/angular-elements/producer/passive-referral-loader/interfaces/passive-referral-loader.interface';
import { GlobalShadowStyleDirective, BooleanInput } from '@ptl/global-components';

@Component({
    selector: 'app-zip-county-modal-trigger',
    templateUrl: './zip-county-modal-trigger.component.html',
    styleUrls: ['./zip-county-modal-trigger.component.scss'],

    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ZipCountyModalTriggerComponent extends GlobalShadowStyleDirective implements OnInit {

  @Input() viewPlansUrl: string;
  @Input() connectureUrl: string;
  @Input() recommendedPlansUrl: string;
  @Input() buttonStyle: string;
  @Input() tabPreselect: string;

  @Input() modalHeading: string;
  @Input() modalContentMain: string;
  @Input() modalButtonLabel: string;
  @Input() connectureButtonLabel: string;

  @Input() hideYearSelection: string;
  @Input() hideEdit: string;

  @Input() currentYearOverride: string;
  @Input() selectYearHeading: string;
  @Input() selectYearPrompt: string;
  @Input() initialYearSelection: string = 'nextYear';
  @Input() tooltipText: string;

  @Input() verboseSubHeader: string;
  @Input() viewMode: string;

  @Input() forceBranding: string;
  @Input() redirectClosedUrl: string;
  @Input() hideEditButton: string;
  @Input() @BooleanInput() includeEmailField: boolean;

  @Input() @BooleanInput() hideViewPlansButton: boolean = false;
  @Input() @BooleanInput() showConnectureButton: boolean = false;
  @Input() @BooleanInput() isConnectureNewTab: boolean = false;


  @select(['appStates', 'EffectiveDate']) effectiveDate$: Observable<EffectiveDateStateStructure>;

  countyInfo: ZipCountyStateStructure;
  effectiveDate: EffectiveDateStateStructure;
  yearSelected: string;
  displayEffectiveDate = 'MM/DD/YYYY';
  isAuthoring: boolean = false;
  zipcountyState: ZipCountyStateStructure;
  isSearchResult: boolean = true;
  isHideOptions: boolean = false;
  shouldShowEmailField: boolean = false;
  constructor(
    private date: DateService,
    private matDialog: MatDialog,
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService,
    private authoringMode: AuthoringModeService,
    private cookies: CookieService
  ) { 
    super();
  }

  get hideEditButtonBool() {
    return this.hideEditButton === 'true' ? true : false;
  }

  ngOnInit() {
    this.zipcountyState = this.reducerUtilityService.getState('ZipCounty');
    const passiveReferralData: ProducerUrlSessionObject = this.reducerUtilityService.getState('PassiveReferrals')
    this.isAuthoring = this.authoringMode.getAuthoringMode();
    this.countyInfo = this.reducerUtilityService.getState('ZipCounty');

    this.effectiveDate$.subscribe((value) => {
      this.effectiveDate = value;
      this.yearSelected = this.effectiveDate?.effectiveDateYear || 'Year Not Chosen';
      this.displayEffectiveDate = this.date.getDateAsFormattedString(this.effectiveDate.effectiveDate, 'MM/DD/YYYY');
    });
    
    this.shouldShowEmailField = (this.includeEmailField && passiveReferralData.agencyNumber) ? true : false;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    const youreAFineGirl = this.cookies.get('brand');


    const passiveReferralData: ProducerUrlSessionObject = this.reducerUtilityService.getState('PassiveReferrals')
    const emailTypePreference = passiveReferralData?.emailTypePreference;


    if (this.forceBranding === 'true' && (!youreAFineGirl || !this.countyInfo.zipCode) && !this.isAuthoring) {
      if (this.includeEmailField) {
        if (emailTypePreference === 'PRODUCER_URL') {
          this.openZipModal(true);
        }
      } else {
        this.openZipModal(true);
      }
    }

  }

  setZipCounty(forceZip?: false) {
    if (!forceZip && environment.initData.brand.singleBrandASP) {
      window.location.href = `./${this.viewPlansUrl}`;
    } else {
      this.openZipModal();
    }

  }

  goToUrl() {
    window.location.assign(this.viewPlansUrl);
  }

  hideOptions() {
    this.isSearchResult = true;
    this.isHideOptions = false;
  }

  searchResult() {
    this.isSearchResult = false;
    this.isHideOptions = true;
  }


  openZipModal(disableClose: boolean = false) {
    if (this.tabPreselect) {
      this.ngRedux.dispatch(setActiveProductGroup(PRODUCT_GROUPS[this.tabPreselect]));
    }

    this.matDialog.open(ZipCountyModalComponent, {
      disableClose,
      maxWidth: '650px',
      maxHeight: '100vh',
      data: {
        forceBranding: this.forceBranding,
        viewPlansUrl: this.viewPlansUrl,
        connectureUrl: this.connectureUrl,
        recommendedPlansUrl: this.recommendedPlansUrl,
        redirectClosedUrl: this.redirectClosedUrl,
        includeEmailField: this.shouldShowEmailField,
        hideViewPlansButton: this.hideViewPlansButton,
        showConnectureButton: this.showConnectureButton,
        isConnectureNewTab: this.isConnectureNewTab,
        yearSelectionConfig: {
          hideYearSelection: this.hideYearSelection === 'true',
          currentYearOverride: this.currentYearOverride,
          selectYearHeading: this.selectYearHeading,
          selectYearPrompt: this.selectYearPrompt,
          initialYearSelection: this.initialYearSelection,
          tooltipText: this.tooltipText
        },
        modalContent: {
          heading: this.modalHeading,
          contentMain: this.modalContentMain,
          buttonLabel: this.modalButtonLabel,
          connectureButtonLabel: this.connectureButtonLabel
        }
      }
    });
  }

  isMultiBrandASP() {
    return !environment.initData.brand.singleBrandASP;
  }

}
